import { useEffect, useState } from 'react';

export function useOptimisticState<T>(
	serverValue: T,
): [T, (value: T | null) => void] {
	const [optimistic, setOptimistic] = useState<T | null>(null);

	useEffect(() => {
		if (
			optimistic !== null &&
			JSON.stringify(serverValue) === JSON.stringify(optimistic)
		) {
			setOptimistic(null);
		}
	}, [serverValue, optimistic]);

	const display = optimistic ?? serverValue;
	return [display, setOptimistic];
}
